import AboutHero from "../components/about-hero";
import AboutOne from "../components/about-one";
import AboutTwo from "../components/about-two";
import AboutThree from "../components/about-three";

function About() {
  return (
    <>
      <div>
        <AboutHero />
        <AboutOne />
        <AboutTwo />
        <AboutThree />
      </div>
    </>
  );
}

export default About;
